// 광고 유닛 ID를 프록시(bwek-judge)에서 원격으로 읽는다 — 빌드에 ID를 박지 않아 스토어 재심사 없이 교체 가능.
// 실패·누락이면 ads.ts의 구글 공식 테스트 ID 폴백이 쓰인다(앱은 절대 막히지 않음).
// ⚠️ 게이트 구조(전면/보상형)·노출 위치·양은 코드에 고정 — 원격으로 바뀌는 건 '수익 ID'뿐(App Store 2.3.1).

const MOON = (import.meta.env.VITE_MOON_ENDPOINT as string | undefined) ?? "";
// .../api/hyuh → .../api/hyuh/config
const CONFIG_URL = MOON ? MOON.replace(/\/+$/, "") + "/config" : "";

export interface AdSlot {
  ios?: string;
  android?: string;
}
export interface AdConfig {
  interstitial?: AdSlot;
  rewarded?: AdSlot;
}

let cached: AdConfig | null = null;

/** 앱 시작 시 1회(initAds 내부에서 await). 실패해도 조용히 폴백(테스트 ID). */
export async function loadAdConfig(): Promise<void> {
  if (!CONFIG_URL || cached) return;
  try {
    const res = await fetch(CONFIG_URL, { method: "GET" });
    if (!res.ok) return;
    const data = (await res.json()) as { ads?: AdConfig };
    if (data?.ads) cached = data.ads;
  } catch {
    /* 네트워크 실패 → 테스트 ID 폴백 */
  }
}

export function adConfig(): AdConfig | null {
  return cached;
}
